import { render, staticRenderFns } from "./SmsAvatar.vue?vue&type=template&id=5af4d2fb&scoped=true&"
import script from "./SmsAvatar.vue?vue&type=script&lang=js&"
export * from "./SmsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SmsAvatar.vue?vue&type=style&index=0&id=5af4d2fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4d2fb",
  null
  
)

export default component.exports